import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import { useIntl } from 'react-intl';

import ScoutIcon from '@/assets/chatbot/scout-wave-transparent.png';
import { useBreakpointContext } from '@/components/common/BreakpointContext';

import { TChatbotButtonProps } from './ChatbotContainer';

const HomePageButton = ({ handleOpen }: TChatbotButtonProps) => {
  const intl = useIntl();
  const { isAboveDesktop } = useBreakpointContext();

  return (
    <>
      <Text
        className="text-gray-50"
        variant={isAboveDesktop ? ETextStyleVariant.LargeBold : ETextStyleVariant.MediumBold}>
        {intl.formatMessage({
          defaultMessage: 'OR',
          id: 'INlWvJ',
        })}
      </Text>
      <button onClick={handleOpen}>
        <div className="relative flex flex-row items-center justify-start p-2 bg-gray-800 rounded-full gap-3 h-[52px] lg:h-[100px]">
          <div className="absolute bottom-0 left-2.5 lg:left-3">
            <Image
              src={ScoutIcon}
              width={isAboveDesktop ? 80 : 40}
              height={isAboveDesktop ? 80 : 40}
              alt="Scout icon"
            />
          </div>
          <div className="flex flex-col items-start pr-4 pl-14 lg:pl-24 lg:pr-8">
            <Text
              className="leading-tight text-left text-white whitespace-nowrap"
              variant={ETextStyleVariant.SmallRegular}>
              {intl.formatMessage({
                defaultMessage: 'Search with',
                id: 'sDwfFD',
              })}
            </Text>
            <Text
              className="leading-tight text-left text-white whitespace-nowrap"
              variant={isAboveDesktop ? ETextStyleVariant.LargeBold : ETextStyleVariant.MediumBold}>
              {intl.formatMessage({
                defaultMessage: 'Scout',
                id: 'BQ4DlU',
              })}
            </Text>
          </div>
        </div>
      </button>
    </>
  );
};

export default HomePageButton;
